import { render, staticRenderFns } from "./BreedStandardList.vue?vue&type=template&id=520a372a&scoped=true&"
import script from "./BreedStandardList.vue?vue&type=script&lang=js&"
export * from "./BreedStandardList.vue?vue&type=script&lang=js&"
import style0 from "./BreedStandardList.vue?vue&type=style&index=0&id=520a372a&lang=scss&scoped=true&"
import style1 from "./BreedStandardList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a372a",
  null
  
)

export default component.exports